import {
  ApplianceSettings,
  ApplianceType,
  MatroxD4ApplianceSettings,
  MatroxE4ApplianceSettings,
  MatroxS1ApplianceSettings,
  NimbraVAApplianceSettings,
} from 'common/api/v1/types'
import { Checkbox } from '../../../../common/Form'
import MatroxE4SettingsComp from './MatroxE4SettingsComp'
import MatroxD4SettingsComp from './MatroxD4SettingsComp'
import MatroxS1SettingsComp from './MatroxS1SettingsComp'
import { isVaApplianceType } from 'common/applianceTypeUtil'
import NimbraVaSettingsComp from './NimbraVaSettingsComp'

interface Props {
  devMode: boolean
  type: ApplianceType
  settings: ApplianceSettings | undefined
}

const ApplianceSpecificSettings = ({ type, settings }: Props) => {
  return (
    <>
      <Checkbox
        label={'Use dynamic tunnel client source address (0.0.0.0)'}
        name={`settings.useDynamicTunnelClientSourceAddress`}
        tooltip="Enabling this setting will ensure that new tunnels are created with a source address of 0.0.0.0. Enable this on appliances where you want to use multiple NICs for the video traffic."
      />
      <Checkbox
        label={'Use ephemeral local ports for tunnels'}
        name={`settings.useEphemeralTunnelSenderPorts`}
        tooltip="Enabling this setting will make tunnels scale better over the available cores and can provide significant performance improvements for high traffic appliances. The tunnel data traffic will originate from ports in the ephemeral range. This setting should only be enabled when there are no firewall restrictions on source ports and there is no symmetric NAT in front of the edge appliance when it has Outputs configured on it. Enabling this will cause a short service disruption during reconfiguration."
      />

      {[ApplianceType.matroxMonarchEdgeD4].includes(type) && (
        <MatroxD4SettingsComp settings={settings as MatroxD4ApplianceSettings} />
      )}
      {[ApplianceType.matroxMonarchEdgeS1].includes(type) && (
        <MatroxS1SettingsComp settings={settings as MatroxS1ApplianceSettings} />
      )}
      {isVaApplianceType(type) && <NimbraVaSettingsComp settings={settings as NimbraVAApplianceSettings} />}
      {[ApplianceType.matroxMonarchEdgeE4_8Bit, ApplianceType.matroxMonarchEdgeE4_10Bit].includes(type) && (
        <MatroxE4SettingsComp
          settings={settings as MatroxE4ApplianceSettings}
          applianceType={type as ApplianceType.matroxMonarchEdgeE4_8Bit | ApplianceType.matroxMonarchEdgeE4_10Bit}
        />
      )}
    </>
  )
}

export default ApplianceSpecificSettings
